import { get as dig } from 'lodash';
import { gql, useQuery } from '@apollo/client';

import { canAccessFeature, FEATURES } from 'helpers/features';
import { MANUAL_PLAN_ID } from 'components/billing/constants';

// Never advertise Project Collaboration to users on these plan types
const NEVER_UPSELL = [MANUAL_PLAN_ID];

const VIEWER_COMPANY_COLLABORATION_FEATURE_QUERY = gql`
  query CompanyPlanFeatures {
    viewer {
      id
      company {
        id
        databaseId
        plan {
          id
          identifier
        }
        featureSet {
          projectCollaboration
        }
      }
    }
  }
`;

export default () => {
  const {
    data,
    loading: planLoading,
    error: planError,
  } = useQuery(VIEWER_COMPANY_COLLABORATION_FEATURE_QUERY);
  const currentPlan = dig(data, 'viewer.company.plan', {});
  const featureSet = dig(data, 'viewer.company.featureSet', {});

  const canAccessProjectCollaborations = canAccessFeature(
    featureSet,
    FEATURES.PROJECT_COLLABORATION,
  );

  const shouldNeverBeUpsoldTo = NEVER_UPSELL.includes(
    dig(currentPlan, 'identifier'),
  );

  return {
    hasCollaborationAccess: canAccessProjectCollaborations,
    shouldUpsellCollaboration:
      !canAccessProjectCollaborations && !shouldNeverBeUpsoldTo,
    loading: planLoading,
    error: planError,
  };
};
